import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 194px;
  background-color: ${({ theme }) => theme.backgrounds.sidebarSubMenu};
  position: absolute;
  top: 0;
  right: -194px;
  text-align: left;
  padding: 8px 0;
  z-index: 99;

  border-radius: 3px;
  box-shadow: 0 2px 50px 0 rgba(28, 34, 67, 0.1);
`;

export const SideBarSubMenuItem = styled.div`
  display: flex;
  cursor: pointer;
  height: 34px;
  padding-left: 23px;
  align-items: center;
  font-size: 13.5px;
  line-height: 1.2;
  color: ${({ theme }) => theme.text.sidebarSubMenu};
  ${({ selected }) => selected && 'font-weight: 600;'}

  &:hover {
    background-color: ${({ theme }) => theme.backgrounds.sidebarSubMenuItemHover};
  }

`;

export const SubMenuHeader = styled(SideBarSubMenuItem)`
 background-color: ${({ theme }) => theme.backgrounds.sidebarSubMenuHeader};
 color: #fafbfc;
 font-weight: bold;
 margin-top: -8px;
 cursor: default;
 
 &:hover {
  background-color: ${({ theme }) => theme.backgrounds.sidebarSubMenuHeaderHover};
 }
`;
